// Footer columns. An item without `href` renders as "Coming soon" text, not a
// link, so the footer never advertises a page that does not exist.
import { ALTERNATIVES, pathForAlternative } from "./alternatives.mjs";
import { DOCS, pathForDoc } from "./docs.mjs";

export const FOOTER_COLUMNS = [
  { title: "Product", items: [
    { name: "Use cases", href: "/use-cases" },
    { name: "Integrations", href: "/integrations" },
    { name: "Pricing", href: "/#pricing" },
    { name: "FAQs", href: "/#faq" },
    { name: "Dashboard", href: "/dashboard" },
  ] },
  { title: "Solutions", items: [
    { name: "Small business owners", href: "/use-cases/small-business" },
    { name: "SEO agencies", href: "/use-cases/agencies" },
    { name: "Operations teams" },
  ] },
  { title: "Resources", items: [
    ...DOCS.map(d => ({ name: d.nav, href: pathForDoc(d.slug) })),
    { name: "All docs", href: "/docs" },
    { name: "Blog" },
  ] },
  { title: "Free tools", items: [
    { name: "Single-page SEO check", href: "/tools/seo-check" },
    { name: "llms.txt generator" },
  ] },
  { title: "Alternatives", items: ALTERNATIVES.map(a => ({ name: a.nav, href: pathForAlternative(a.slug) })) },
  { title: "Company", items: [
    { name: "Contact us", href: "/contact" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
    { name: "Cookie Policy", href: "/cookies" },
    { name: "Acceptable Use Policy", href: "/acceptable-use" },
  ] },
];
